import {observer} from "mobx-react";
import './scrollable.scss';
import {useCallback, useEffect, useRef} from "react";

export interface IScrollableProps {
    children?: React.ReactNode;
    direction?: SCROLLABLE_DIRECTION;
    scrollToNewElements?: boolean;
}

export enum SCROLLABLE_DIRECTION {
    VERTICAL = 'scrollable-vertical',
    HORIZONTAL = 'scrollable-horizontal',
    BOTH = 'scrollable-both'

}

const Scrollable : React.FC<IScrollableProps> = observer(({
    children,
    direction = SCROLLABLE_DIRECTION.VERTICAL,
    scrollToNewElements = true
})=> {
    const ref = useRef<HTMLDivElement>(null);
    const callback = useCallback((mutationsList: MutationRecord[]) => {
        mutationsList.forEach((mutation: MutationRecord) => {
            if (mutation.addedNodes.length && scrollToNewElements) {
                const lastNode = mutation.addedNodes[mutation.addedNodes.length - 1] as HTMLElement;
                if(ref.current && lastNode && lastNode.scrollIntoView) {
                    if(lastNode.isConnected === false){
                        return;
                    }
                    if(isChildOfSelectDropdown(lastNode)){
                        return;
                    }
                    const isNodeInView = isElementInView(lastNode, ref.current);
                    if (!isNodeInView){
                        lastNode.scrollIntoView({behavior: 'smooth', block: 'center'});
                    }
                }
            }
        });
    }, [scrollToNewElements]);

    useEffect(() => {
        const observer = new MutationObserver(callback);
        if (ref.current) {
            observer.observe(ref.current, {subtree: true, childList: true});
        }
        return () => {
            observer.disconnect();
        }
    }, [callback]);
    
    return (
        <div className={`scrollable ${direction}`} ref={ref}>
            {children}
        </div>
    )
});

export default Scrollable;


function isChildOfSelectDropdown(element: HTMLElement) {
    return !!element.closest('.select-dropdown') || !!element.closest('.select-dropdown-grouped');
}

function isElementInView(element: HTMLElement, parentEleement: HTMLElement) {
    const parentRect = parentEleement.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    return (
        elementRect.top >= parentRect.top &&
        elementRect.left >= parentRect.left &&
        elementRect.bottom <= parentRect.bottom &&
        elementRect.right <= parentRect.right
    );
};
